import { ButtonGroupInput } from "./ButtonGroupInput";
import type { IntakeFormData } from "../../types/form";
import type { useStepValidation } from "../../hooks/useStepValidation";

export type YesNoField = {
  [K in keyof IntakeFormData]: IntakeFormData[K] extends "Yes" | "No" | "" | null ? K : never;
}[keyof IntakeFormData];

interface YesNoInputProps {
  field: YesNoField;
  label: string;
  required?: boolean;
  containerClassName?: string;
  validation: ReturnType<typeof useStepValidation>;
  onChange?: (value: "Yes" | "No") => void;
  /** Return false to prevent the value from being set. Use for confirmation guards. */
  onBeforeChange?: (value: "Yes" | "No") => boolean;
  noPrefill?: boolean;
  /** Static helper text rendered below the Yes/No buttons. */
  hint?: string;
}

/**
 * Yes/No button group for Salesforce restricted picklist fields typed "Yes" | "No" | null.
 * Prefer this over ToggleInput for picklist-backed fields — null represents unanswered,
 * whereas a boolean always defaults to false and silently pre-selects "No".
 */
export function YesNoInput({ field, label, required, containerClassName, validation, onChange, onBeforeChange, noPrefill, hint }: YesNoInputProps) {
  return (
    <ButtonGroupInput
      field={field}
      label={label}
      options={["Yes", "No"]}
      validation={validation}
      required={required}
      containerClassName={containerClassName}
      onChange={onChange as (value: string) => void}
      onBeforeChange={onBeforeChange as ((value: string) => boolean) | undefined}
      noPrefill={noPrefill}
      hint={hint}
    />
  );
}
